import { render, staticRenderFns } from "./Actores.vue?vue&type=template&id=f542d5c2&"
import script from "./Actores.vue?vue&type=script&lang=js&"
export * from "./Actores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports